import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "@components"
import {useMarketplacesSellerDeepDiveReportForm} from "../../@hooks";

export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useMarketplacesSellerDeepDiveReportForm()

    return <Box componet="span" data-tour="seller-deep-dive-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}